import {DropDownList, DropDownListChangeEvent} from "@progress/kendo-react-dropdowns"
import PropTypes from "prop-types"
import {setUserRegionsAction} from "../../containers/App/appSlice"
import {useDispatch} from "react-redux"
import {Field, FieldRenderProps, Form, FormElement, FormRenderProps} from "@progress/kendo-react-form"
import {Button} from "@progress/kendo-react-buttons"
import {useState} from "react"
import {UserRegion} from "../../containers/App/models"
import { Drawer } from "@volvo/vcdk-react/Drawer";
import { DrawerContent } from "@volvo/vcdk-react/DrawerContent";
import { IconButton } from "@volvo/vcdk-react/IconButton";
const UserSettings = ({
    toggleSettingsDialog,
    closeSettingsDialog,
    userInfo,
    userRegions,
    selectedRegion,
    signOutUser,
}: {
    toggleSettingsDialog: any
    closeSettingsDialog: any
    userInfo: any
    userRegions: UserRegion[]
    selectedRegion: UserRegion
    signOutUser: (any: string) => void
}) => {
    const dispatch = useDispatch()

    const [defaultRegion, setDefaultRegion] = useState(selectedRegion)

    const onChange = (event: DropDownListChangeEvent) => {
        setDefaultRegion(event.target.value)
    }

    const onSetActiveRegion = (e: any) => {
        dispatch(setUserRegionsAction(defaultRegion.regionId))
    }

    const RegionsDropdown = (fieldRenderProps: FieldRenderProps) => {
        const {onChange} = fieldRenderProps
        return (
            <DropDownList
                onChange={onChange}
                textField="regionName"
                dataItemKey="regionId"
                value={defaultRegion}
                data={userRegions}
            />
        )
    }

    return (
        <Drawer width="300px" side="end" open={toggleSettingsDialog} mode="modal" onClose={() =>{  closeSettingsDialog(false) }} style={{position: "relative", zIndex: 1055}}>
            <DrawerContent fullSize={true}>
                <div style={{paddingLeft: "1rem",flex: "1 1 auto", position: "relative"}}>
                    <div>
                        <IconButton
                            icon="close"
                            className="float-end"
                            onClick={() => {
                                closeSettingsDialog(false)
                            }}
                        />
                    </div>
                    <div>
                        <div className="card-header ps-0">
                            <span className="font-weight-bold">{userInfo.name}</span>
                            <p className="card-text">{userInfo.username}</p>
                            <div>
                                <a style={{"color":"royalblue"}} href="https://www.volvotrucks.in/en-in/tools/privacy.html"> Privacy notice</a>
                            </div>
                        </div>
                    </div>
                    <div className="mt-4 w-100">
                        <Form
                            onSubmit={onSetActiveRegion}
                            render={(formRenderProps: FormRenderProps) => (
                                <>
                                    <div className="mb-2">
                                        <FormElement>
                                            <fieldset className={"k-form-fieldset"}>
                                                <div>Selected Region</div>
                                                <Field
                                                    onChange={onChange}
                                                    name={"customerSearch"}
                                                    component={RegionsDropdown}
                                                    label={"Search customer"}
                                                />
                                            </fieldset>
                                        </FormElement>
                                    </div>
                                    <div className="k-form-buttons mt-auto justify-content-center">
                                        <Button
                                            type="submit"
                                            fillMode="flat"
                                            themeColor={"primary"}
                                            disabled={!formRenderProps.allowSubmit}
                                            onClick={formRenderProps.onSubmit}
                                        >
                                            Set as active
                                        </Button>
                                    </div>
                                </>
                                )}
                        />
                    </div>
                </div>
            </DrawerContent>
            <div style={{ position: "absolute",bottom: 0,
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
                width: "300px",
                padding: "0.75rem"}}>
                    <Button
                        type="submit"
                        fillMode="outline"
                        themeColor={"primary"}
                        onClick={() => {
                            signOutUser("redirect")
                        }}
                    >
                        Logout
                    </Button>
            </div>
        </Drawer>
    )
}

UserSettings.prototype = {
    toggleSettingsDialog: PropTypes.bool,
    setOpenCloseSettingsDialog: PropTypes.bool,
    newCustomerDetails: PropTypes.func,
}
export default UserSettings
